import { makeAutoObservable } from 'mobx';
import { apiService } from '../services/api';
import { SystemSettings } from '../types';

class SystemSettingsStore {
  settings: SystemSettings | null = null;
  isLoading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async loadSettings() {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await apiService.get<{ data: SystemSettings }>('/v1/root/system-settings');
      this.settings = response.data;
    } catch (error: any) {
      this.error = error.message;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async updateSettings(settings: SystemSettings) {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await apiService.put<{ data: SystemSettings }>('/v1/root/system-settings', settings);
      this.settings = response.data;
    } catch (error: any) {
      this.error = error.message;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async updateOpenAIKey(apiKey: string) {
    this.isLoading = true;
    this.error = null;
    try {
      await apiService.put('/v1/root/system-settings/openai-key', { openaiApiKey: apiKey });
      await this.loadSettings(); // Reload settings after update
    } catch (error: any) {
      this.error = error.message;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async updateDefaultTemplates(templates: SystemSettings['defaultMessageTemplates']) {
    this.isLoading = true;
    this.error = null;
    try {
      await apiService.put('/v1/root/system-settings/default-templates', templates);
      await this.loadSettings(); // Reload settings after update
    } catch (error: any) {
      this.error = error.message;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async updateGoogleAIKey(apiKey: string) {
    this.isLoading = true;
    this.error = null;
    try {
      await apiService.put('/v1/root/system-settings/google-ai-key', { googleAiApiKey: apiKey });
      await this.loadSettings(); // Reload settings after update
    } catch (error: any) {
      this.error = error.message;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
}

export const systemSettingsStore = new SystemSettingsStore();